// 按钮类型枚举
export const BTN_MAP_KEY = {
  DRAW: Symbol(), // 开始绘制
  EDIT: Symbol(), // 开始编辑
  DELETE: Symbol(), // 删除所有
  DELETE_LAST: Symbol(), // 删除最后一根
  IS_SLASH: Symbol(),
  DELETE_ALL: Symbol(),
}

// flushEffect时优先级枚举
// 高优先级会直接执行 低优先级会被推入LongTask下队列 在浏览器空闲时间片执行
// 目前只有在支持requestIdleCallback的浏览器可得到优化 不兼容降级为全高优先级同步执行
export const EFFECT_LEVEL = {
  HEIGH: Symbol(), // 高优先级
  LOW: Symbol(), // 低优先级
}

// 线的方向枚举
export const LINE_DIR = {
  ROW: Symbol(), // 横向
  COL: Symbol(), // 纵向
  ROWLR: Symbol(), // 横向 左至右
  ROWRL: Symbol(), // 纵向 右至左
  COLTB: Symbol(), // 纵向 上至下
  COLBT: Symbol(), // 纵向 下至上
  ANGLE_ROW_LR: Symbol(), // 斜角 横向 左至右
  ANGLE_ROW_RL: Symbol(), // 斜角 纵向 右至左
  ANGLE_COL_TB: Symbol(), // 斜角 纵向 上至下
  ANGLE_COL_BT: Symbol(), // 斜角 纵向 下至上
}

// 整个插件的类型
export const MODE_TYPE = {
  LINE: 'LINE', // 直角模式
  CIRCLE: 'CIRCLE', // 圆圈模式
  TEMPLATE: 'TEMPLATE'
}

// 图形维度枚举 【 为使储存服务端数据精简 】
export const SHAP_TYPE = {
  LINE: 'L', // 线
  CIRCLE: 'C' // 点
}

// 业务维度枚举 【 为使储存服务端数据精简 】
export const FUN_TYPE = {
  LINE: 'L', // 线灯带
  CIRCLE: 'C', // 圆形灯带
  POINTER: 'P', // 点
  LAMP: 'LA' // 灯
}

// 点线的布局模式 【 为使储存服务端数据精简 】
export const LINE_LAYOUT_SERVICE_MODE = {
  LINK: 'L',
}

// 圆的布局模式 【 为使储存服务端数据精简 】
export const CIRCLE_LAYOUT_SERVICE_MODE = {
  SIMPLE: 'S',
}

// 灯的布局模式 【 为使储存服务端数据精简 】
export const LAMP_LAYOUT_SERVICE_MODE = {
  AVERAGE: 'A', // 均分
  SIMGLE_LINE_AVERAGE: 'SA' // 每根线上不一样
}

export const EFFECT_TAG = {
  NO_EFFECT: 0,
  MOVE: 1,
  POSITION: 2,
  LINE_SIZE: 4,
  WIDTH: 8,
  HEIGHT: 16,
  POINTS: 32,
  DELETE: 64,
  UPDATE_RENDER_DATA: 128,
  RADIUS: 256,
}